import { ProductListConfig } from 'rangeConfig/@types';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';

const tapsProductListConfig: ProductListConfig = {
  cardsTitle: '',
  cardsSubtitle: 'typeName, designText, communicatedSizeText',
  infoButtonAriaLabel: 'storageone.productListCabinetsTitle',
  cluster: [],
  behaviors: {
    productClicked: [addProduct],
    productDropped: [addProduct]
  },
  sortOrder: [],
  categories: [
    {
      id: 'taps',
      products: []
    }
  ]
};

export default tapsProductListConfig;
